import { useRef, useState, useCallback } from 'react';

/**
 * Custom hook for handling file uploads and drag-and-drop
 */
export function useFileHandler() {
  const [rawJson, setRawJson] = useState("");
  const [error, setError] = useState("");
  const [fileName, setFileName] = useState("conversation.md");
  const fileInputRef = useRef(null);

  const processFile = useCallback((file) => {
    if (!file) return;
    
    setError("");
    setFileName(file.name.replace(/\.(json)$/i, "") + ".md");
    
    file.text()
      .then(setRawJson)
      .catch((err) => setError(`Failed to read file: ${String(err)}`));
  }, []);

  const handleFile = useCallback((e) => {
    const file = e.target.files?.[0];
    processFile(file);
  }, [processFile]);

  const handleDrop = useCallback((ev) => {
    ev.preventDefault();
    const file = ev.dataTransfer?.files?.[0];
    processFile(file);
  }, [processFile]);

  const handleDragOver = useCallback((ev) => {
    ev.preventDefault();
  }, []);

  const openFileDialog = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const clearFile = useCallback(() => {
    setRawJson("");
    setError("");
    setFileName("conversation.md");
  }, []);

  return {
    rawJson,
    error,
    fileName,
    fileInputRef,
    handleFile,
    handleDrop,
    handleDragOver,
    openFileDialog,
    clearFile,
  };
}
